import React, { memo } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Query from 'components/shared/Query'
import UseExistingEstateDialog from './UseExistingEstateDialog'

const existingAddressQuery = gql`
  query ExistingEstate($cadastreId: ID!) {
    viewer {
      id
      broker {
        id
        estatesOnAddress(cadastreId: $cadastreId) {
          edges {
            node {
              id
              invisoRef
              customerRef
            }
          }
        }
      }
    }
  }
`

const ExistingEstate = ({cadastreId, onNewOrderOnExistingEstate, onNewEstate}) => {
  return (
    <Query
        inlineError
        query={existingAddressQuery}
        variables={{
          cadastreId,
        }}
      >
        {({getData, loading}) => {
          if (!loading) {
            const edges = getData('viewer.broker.estatesOnAddress.edges')
            if (edges.length) {
              return (
                <UseExistingEstateDialog
                  estate={edges[0].node}
                  onNewOrderOnExistingEstate={onNewOrderOnExistingEstate}
                  onNewEstate={onNewEstate}
                />
              )
            }
          }

          return null
        }}
      </Query>
  )
}

ExistingEstate.propTypes = {
  cadastreId: PropTypes.string,
  onNewOrderOnExistingEstate: PropTypes.func,
  onNewEstate: PropTypes.func,
}

export default memo(ExistingEstate)
